import { useUser } from "lib/apollo/hooks"
import type { RegionType, User } from "lib/apollo/types"
import { useRouter } from "lib/router"
import { useEffect } from "react"
import { initGTM, useIsGTMEnabled } from "utils/gtm"
import { initGTMImpressions } from "utils/gtm/impressions"
import { isBrowser } from "utils/isBrowser"
import { getRegion } from "lib/apolloClient"
import { useCurrencyCode } from "./useCurrencyCode"

const useServerGTM = () => {
  return null
}

const useClientGTM = (eventId, is404 = false): void => {
  const { asPath } = useRouter()
  const region = getRegion()
  const isGTMEnabled = useIsGTMEnabled()
  const user = useUser()
  const currencyCode = useCurrencyCode()

  useEffect(() => {
    if (isGTMEnabled) {
      initGTM(region as RegionType, asPath, user as User, eventId, is404)
      initGTMImpressions(currencyCode)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [region, user, asPath, currencyCode])
}

export const useGTM = isBrowser() ? useClientGTM : useServerGTM
